import ConsultanteNovo from './ConsultanteNovo';

export default ConsultanteNovo;